import React from 'react';
import { KOSTEN_POSITION } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import {
	checkIfAllPositionIsEditable,
	checkIfAnyPositionNachPositionArtHasComment,
	checkIfHasComment,
} from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import { TreeStructureAntragAbschlussSeiteGlobal } from '../../global-structure/abschluss-seite/TreeStructureAbschlussSeiteGlobal';
import { TreeStructureAllgemeinHinweisGlobal } from '../../global-structure/allgemeinen-hinweis/TreeStructureAllgemeinHinweisGlobal';
import { TreeStructureAnlagenGlobal } from '../../global-structure/anlagen/TreeStructureAnlagenGlobal';
import { TreeStructureAntragBescheidGlobal } from '../../global-structure/antrag-bescheid/TreestructureAntragBescheidGlobal';
import { TreeStructureAntragstellerGlobal } from '../../global-structure/antragstellerin/TreeStructureAntragstellerGlobal';
import { TreeStructureDeMinimisGlobal } from '../../global-structure/de-minimis/TreeStructureDeMinimisGlobal';
import { TreeStructureErklaerungGlobal } from '../../global-structure/erklaerung/TreeStructureErklaerungGlobal';
import { TreeStructureSelbstErklaerungRUSGlobal } from '../../global-structure/rus-erklaerung/TreeStructureSelbstErklaerungRUSGlobal';
import { TreeStructureSelbstErklaerungKMUGlobal } from '../../global-structure/selbst-erklaerung-kmu/TreeStructureSelbstErklaerungKMUGlobal';
import { TreeStructureSelbstErklaerungBeihilferelevanzGlobal } from '../../global-structure/beihilferelevanz-erklaerung/TreeStructureSelbstErklaerungBeihilferelevanzGlobal';
import { TreeStructureAntragVorzeitigerMassnahme } from '../../global-structure/vorzeitige-massnahme/TreeStructureVorzeitigeMassnahmeGlobal';
import { TreeStructureZeitplanungGlobal } from '../../global-structure/zeitplanung/TreeStructureZeitplanungGlobal';
import AusgabeplanMessefoerderung, { getFormStrucAusgabeplanMessefoerderung } from './content/AusgabeplanMessefoerderung';
import FinanzierungsplanMessefoerderung, { getFormStrucFinanzierungsplanMessefoerderung } from './content/FinanzierungsplanMessefoerderung';
import MessebeteiligungMessefoerderung, { getFormStrucMessebeteiligungMessefoerderung } from './content/MessebeteiligungMessefoerderung';

// imports schema
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
// import KostenPositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
const P = Schema.attributes;
// const KP_P = KostenPositionSchema.attributes;

export const TreeStructureAntragMessefoerderung = (
	application: any,
	readOnly: boolean,
	allgemeineHinweiseKMU: any,
	allgemeineHinweiseDeminimis: any,
	allgemeineHinweiseRUS: any,
	allgemeineHinweiseBeihilferelevanz: any,
) => {
	const isKostenEditable = checkIfAllPositionIsEditable(readOnly, application);

	let treeNodes: TreeNodeType[] = [
		// Allgemeinen Hinweise Global
		...TreeStructureAllgemeinHinweisGlobal(application),
		// Antragsteller Global
		...TreeStructureAntragstellerGlobal(application, readOnly),
		// Selbsterlärung-KMU Global
		...TreeStructureSelbstErklaerungKMUGlobal(application, readOnly, allgemeineHinweiseKMU),
		// Beihilferelevanz-Erklärungen Global
		...TreeStructureSelbstErklaerungBeihilferelevanzGlobal(application, readOnly, allgemeineHinweiseBeihilferelevanz),
		// RUS-Erklärungen Global
		...TreeStructureSelbstErklaerungRUSGlobal(application, readOnly, allgemeineHinweiseRUS),
		// Deminismis-Selbsterklärung Global
		...TreeStructureDeMinimisGlobal(application, readOnly, allgemeineHinweiseDeminimis),
		// Projektbeschreibung
		...ProjektBschreibung(application, readOnly),
		// Kosten
		...AusgabenPlan(application, readOnly, isKostenEditable),
		...EinnahmenPlan(application, readOnly, isKostenEditable),
		// Zeitplanung Global
		...TreeStructureZeitplanungGlobal(application, readOnly),
		// Anlagen und Erklärung Global
		...TreeStructureAnlagenGlobal(application, readOnly),
		...TreeStructureErklaerungGlobal(application, readOnly),
		// Vorzeitiger Massnahme Global
		...TreeStructureAntragVorzeitigerMassnahme(application, readOnly),
		// Abschluss Global
		...TreeStructureAntragAbschlussSeiteGlobal(application, readOnly),
		// Bescheid Global
		...TreeStructureAntragBescheidGlobal(application),
	];

	return treeNodes;
};

const ProjektBschreibung = (application: any, readOnly: boolean) => {
	const hasComment = checkIfHasComment(
		readOnly,
		application,
		P.Angaben_Zur_Messebeteiligung.schema.attributes.Angaben_Zur_Messebeteiligung_Pruefung_Pruefstatus.path,
	);

	let nodes: TreeNodeType[] = [
		{
			label: 'Angaben zur Messebeteiligung',
			content: <MessebeteiligungMessefoerderung hasComment={hasComment} />,
			hasComment: hasComment,
			formStruc: getFormStrucMessebeteiligungMessefoerderung(application),
		},
	];

	return nodes;
};
const AusgabenPlan = (application: any, readOnly: boolean, isKostenEditable: boolean) => {
	const hasComment = checkIfAnyPositionNachPositionArtHasComment(readOnly, application, KOSTEN_POSITION.Ausgabe);
	let nodes: TreeNodeType[] = [
		{
			label: 'Ausgabenplan',
			content: <AusgabeplanMessefoerderung isKostenEditable={isKostenEditable} />,
			hasComment: hasComment,
			formStruc: getFormStrucAusgabeplanMessefoerderung(application, readOnly),
		},
	];
	return nodes;
};
const EinnahmenPlan = (application: any, readOnly: boolean, isKostenEditable: boolean) => {
	const hasComment = checkIfAnyPositionNachPositionArtHasComment(readOnly, application, KOSTEN_POSITION.Einnahme);
	let nodes: TreeNodeType[] = [
		{
			label: 'Finanzierungsplan',
			content: <FinanzierungsplanMessefoerderung isKostenEditable={isKostenEditable} />,
			hasComment: hasComment,
			formStruc: getFormStrucFinanzierungsplanMessefoerderung(application, readOnly),
		},
	];
	return nodes;
};
